import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import showLiveSupport from '@xanadu/ui-shared/utils/showLiveSupport';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../KycMessaging.module.scss';

const RegistrationSuccess = ({
  depositRequest,
  closeModal,
}) => {
  const handleLiveSupport = () => {
    closeModal();
    showLiveSupport();
  };

  return (
    <Fragment>
      <div>
        <div className={styles.title}>
          Registration Complete
        </div>
        <div className={styles.bold}>
          Thank you for registering with Matchbook, your account has been created.
        </div>
        <div>
          <span>
            {'We require documentation from you in order to complete account verification.'}
          </span>
          <br />
          <br />
          <span>
            {'We will notify you when this is required. If you want to upload them you can do so via your account panel.'}
          </span>
          <br />
          <br />
          <span>
            Our customer service team is on hand to help you with your account via <a role="button" onClick={handleLiveSupport} className={styles.csLink} ><span style={{ textDecoration: 'underline' }}>Live Chat</span></a> if required.
          </span>
        </div>
      </div>
      <div className={styles.containerActions}>
        <Fragment>
          <Button
            sizeType="wider"
            buttonType="flat"
            onClick={closeModal}
          >Explore Matchbook</Button>
          <Button
            sizeType="wider"
            buttonType="primary"
            onClick={depositRequest}
            className={styles.primaryButton}
          >Deposit Now</Button>
        </Fragment>
      </div>
    </Fragment>
  );
};

RegistrationSuccess.propTypes = {
  depositRequest: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default RegistrationSuccess;

